<template>
  <div id="deviceDetailInfo" v-loading="isLoging">
    <el-dialog
      title="国标配置信息"
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div id="shared" style="margin-top: 1rem; margin-right: 100px">
        <el-form ref="deviceDetailInfo" :model="sipServerParam" label-width="140px">
          <el-form-item label="SIP服务器国标ID">
            <el-tag size="medium">{{ sipServerParam.sipCode }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务器国标域ID">
            <el-tag size="medium">{{ sipServerParam.sipDomain }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务器IP">
            <el-tag size="medium">{{ sipServerParam.sipIp }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务器端口">
            <el-tag size="medium">{{ sipServerParam.sipPort }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务器国标账号">
            <el-tag size="medium">{{ sipServerParam.deviceGBCode }}</el-tag>
          </el-form-item>
          <el-form-item label="SIP服务器国标密码">
            <el-tag size="medium">{{ sipServerParam.password }}</el-tag>
          </el-form-item>
          <el-form-item>
            <div style="float: center">
              <el-button @click="close">关闭</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      isLoging: false,
      sipServerParam: {
        sipCode: null,
        sipDomain: null,
        sipIp: null,
        sipPort: null,
        deviceGBCode: null,
        password: null,
      },
    };
  },
  methods: {
    openDialog: function (deviceId) {
      this.getSipInfo(deviceId);
    },
    getSipInfo: function (deviceId) {
      var that = this;
      that
        .$axios({
          method: "get",
          url: "/api/devices/" + deviceId + "/sip",
          params: {
            token: this.$cookies.get("session").token,
          },
        })
        .then(function (res) {
          if (res.data.code == 0) {
            that.sipServerParam = res.data.data;
            that.showDialog = true;
          } else {
            that.$message({
              showClose: true,
              message: "获取失败",
              type: "error",
            });
            that.showDialog = false;
          }
        });
    },
    close: function () {
      console.log("关闭创建窗口");
      this.showDialog = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/DeviceDetailInfo.vue